import { GlobalController } from 'src/shared/global/GlobalController'
import LandfillManagement from './LandfillManagement'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'landfillManagement',
    component: LandfillManagement,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
